import { PRE_PAYMENT, POST_PAYMENT } from './action-types';
import { getRequestStatus } from '../../requests/selectors';

export const prePaymentNeedsLoadingSelector = (state) => typeof state.booking.payment.paymntRecId === 'undefined';
export const [prePaymentIsFetchingSelector, prePaymentHasErrorSelector, prePaymentErrorDataSelector] = getRequestStatus(PRE_PAYMENT);
export const [postPaymentIsFetchingSelector, postPaymentHasErrorSelector, postPaymentErrorDataSelector] = getRequestStatus(POST_PAYMENT);

export const paypalSelector = (state) => state.booking.payment.paypal;
export const paymntRecIdSelector = (state) => state.booking.payment.paymntRecId;
export const paymntUsedSelector = (state) => state.booking.payment.paymntUsed;
export const postPaymentSelector = (state) => state.booking.payment.postPayment;
